import React, { useEffect, useRef } from "react";
import "./App.scss";
import html2canvas from "html2canvas";
import {
  Card,
  Grid,
  Typography,
  Fab,
  Icon,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  Autocomplete,
  FormControl,
  InputAdornment,
  Box,
  CircularProgress,
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from "@mui/material";
import { Container } from "@mui/system";

import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAnalytics, logEvent } from "firebase/analytics";
import { doc, getFirestore, setDoc, collection, getDoc, increment, updateDoc } from "firebase/firestore";
import { blue } from "@mui/material/colors";

// TODO: Replace the following with your app's Firebase project configuration
const firebaseConfig = {
  apiKey: "AIzaSyCe09lj40aD9KTKB0hpA_hP_lfpC2ANOkI",
  authDomain: "petro-89f1b.firebaseapp.com",
  projectId: "petro-89f1b",
  storageBucket: "petro-89f1b.appspot.com",
  messagingSenderId: "187742768944",
  appId: "1:187742768944:web:16f1044db8c4e6a9c102f5",
  measurementId: "G-Z7GQNDDL03",
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const analytics = getAnalytics();

//defines firestore as db

const { amarillo, azul, rojo, verde, morado, naranja } = {
  amarillo: "#F9A51A",
  azul: "#034EA1",
  rojo: "#ED2424",
  verde: "#32AA49",
  morado: "#8F2F91",
  naranja: "#E64610",
};

const Nombre: React.FC<{ nombre: string; hashtag: string; fontSize: number }> = ({ nombre, hashtag, fontSize }) => {
  return (
    <Grid item xs={12}>
      <h5 style={{ color: naranja, fontSize: fontSize * 0.6 }} className="quiero">
        <b>Me llamo </b>
      </h5>
      {nombre.length < 10 ? (
        <h1 className="logo noselect  " style={{ margin: 0, padding: 0, fontSize: fontSize }}>
          {colorearString(nombre)}
        </h1>
      ) : (
        nombre.split(" ").map((nombre: string, index: number) => (
          <h1 className="logo noselect  " style={{ margin: 0, padding: 0 }}>
            {colorearString(nombre)}
          </h1>
        ))
      )}

      <Typography sx={{ color: naranja, marginTop: "1em !important", fontSize: fontSize / 2.2 }} className="quiero">
        {hashtag == "IvánPresidente" && <b>y voto </b>}
        {hashtag == "UnaCampañaConArte" && <b>y quiero </b>}
        {hashtag == "PactoConIván" && <b>y quiero un</b>}
        {hashtag == "CambioPorLaVida" && <b>y quiero un</b>}

        <br />
        <span style={{ color: morado }}>#</span>
        <span className="hashtag" style={{ color: morado, marginTop: "2em" }}>
          {hashtag}
        </span>
      </Typography>
    </Grid>
  );
};

const Imagen: React.FC<{
  hashtag: string;
  nombre: string;
  ratio: string;
  background: string;
  onSave: any;
  onReady?: any;
  meLlamo?: boolean;
  style?: any;
}> = ({ hashtag, nombre, ratio, background, onSave, onReady, meLlamo, style }) => {
  const [randomId] = React.useState(Math.random());

  const [parentWidth, setParentWidth] = React.useState(1);
  const padre: any = useRef(null);
  useEffect(() => {
    setParentWidth(Math.round(padre.current.clientWidth));
    if (onReady) onReady(true);
  }, []);

  return (
    <>
      <Card
        ref={padre}
        elevation={0}
        id={"image" + randomId}
        style={{
          aspectRatio: ratio,
          background: `url('./ig/${background}')`,
          backgroundSize: "contain",
          position: "relative",
        }}
      >
        <div
          className="image"
          style={{
            position: "relative",
            marginTop: "6%",
            marginLeft: "auto",
            marginRight: "auto",
            width: "100%",
            ...style,
          }}
        >
          {meLlamo == false ? (
            <>
              {nombre
                .split(" ")
                .slice(0, 1)
                .map((nombre: string, index: number) => (
                  <h1 className="logo noselect  " style={{ margin: 0, padding: 0, fontSize: parentWidth / 6 }}>
                    {colorearString(nombre)}
                  </h1>
                ))}
              <Typography
                className=""
                sx={{ color: naranja, textAlign: "center", marginTop: "12% !important", fontSize: parentWidth / 15 }}
              >
                <span style={{ color: morado }}>#</span>
                <span className="hashtag" style={{ color: morado, marginTop: "2em" }}>
                  {hashtag}
                </span>
              </Typography>
            </>
          ) : (
            <Nombre nombre={nombre} hashtag={hashtag} fontSize={parentWidth / 6} />
          )}
        </div>
        <Fab
          className="fab"
          onClick={() => {
            onSave({ id: "image" + randomId, background: background, ratio: ratio, meLlamo: meLlamo, style: style });
          }}
          color="primary"
          aria-label="Descargar"
          style={{ position: "absolute", zIndex: 30, bottom: "1em", right: "1em" }}
        >
          <Icon>download</Icon>
        </Fab>
      </Card>
    </>
  );
};

function App() {
  const [nombre, setNombre] = React.useState("TU NOMBRE");
  const [hashtag, setHashtag] = React.useState("IvánPresidente");
  const [descargable, setDescargable] = React.useState(false);
  const [idDescargar, setIdDescargar] = React.useState("");
  const [imagen, setImagen] = React.useState<{
    id: string;
    meLlamo: boolean;
    background: string;
    ratio: string;
    style: any;
  } | null>(null);

  const saveImage = ({ id, background, ratio, meLlamo, style }: any) => {
    setImagen({ id, background, ratio, meLlamo, style });
    let fab = document?.getElementsByClassName("fab") as any;
    //hide all fabs
    for (let i = 0; i < fab.length; i++) {
      fab[i].style.display = "none";
    }
    html2canvas(document?.getElementById("gigante") as any, {
      width: 1080,
      scale: 1,
    })
      .then(function (canvas) {
        document.body.appendChild(canvas);
        setAlertOpen(true);
        canvas.style.display = "none";

        const img = canvas.toDataURL("image/jpg");
        const link = document.createElement("a");
        link.href = img;

        link.download = `image-${Math.random()}.jpg`;
        link.click();
      })
      .then((_) => {
        //show all fabs
        for (let i = 0; i < fab.length; i++) {
          fab[i].style.display = "block";
        }
        logEvent(analytics, "descarga");

        let descargasTotales = doc(db, "contadores", "descargas");
        getDoc(descargasTotales).then((doc: any) => {
          console.log(doc.data().total);
          updateDoc(descargasTotales, {
            total: doc.data().total + 1,
          }).then((_) => {
            console.log("updated");
          });
        });

        setImagen(null);
        setDescargable(false);
      });
  };

  useEffect(() => {
    if (descargable) saveImage(idDescargar);
    logEvent(analytics, "visita");

    let visitasTotales = doc(db, "contadores", "visitas");
    getDoc(visitasTotales).then((doc: any) => {
      console.log(doc.data().total);
      updateDoc(visitasTotales, {
        total: doc.data().total + 1,
      }).then((_) => {
        console.log("updated");
      });
    });
  }, [descargable]);

  const [open, setOpen] = React.useState(true);
  const [alertOpen, setAlertOpen] = React.useState(false);

  const redes = [
    {
      nombre: "Facebook",
      url: "https://www.facebook.com/sharer/sharer.php?u=https://johndoeorestes.github.io/MeLlamoIvanCepeda//",
      logo: "./logo/facebook-brands.svg",
    },
    {
      nombre: "Twitter",
      url: "https://twitter.com/intent/tweet?text=https://johndoeorestes.github.io/MeLlamoIvanCepeda/",
      logo: "./logo/twitter-brands.svg",
    },
    {
      nombre: "WhatsApp",
      url: "whatsapp://send?text=Crea%20tu%20imagen%20con%20tu%20nombre%20en%20https://johndoeorestes.github.io/MeLlamoIvanCepeda/",
      logo: "./logo/whatsapp-brands.svg",
    },
  ];
  return (
    <>
      <Dialog onClose={() => {}} open={alertOpen}>
        <DialogTitle>Tu imagen se está descargando</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description" style={{ maxWidth: "20em" }}>
            Si no encuentras tu imagen, revisa las notificaciones o la galería de tu dispositivo.
          </DialogContentText>
        </DialogContent>
        <List sx={{ pt: 0 }}>
          {redes.map(({ nombre, url, logo }) => (
            <ListItem
              button
              onClick={() => {
                window.open(url, "_blank");
                logEvent(analytics, "compartir" + nombre);
              }}
              key={url}
            >
              <ListItemAvatar>
                <img src={logo} style={{ width: "2em", color: "red", fill: "#ff0000" }} />
              </ListItemAvatar>
              <ListItemText primary={"Compartir en " + nombre} />
            </ListItem>
          ))}
          <ListItem
            autoFocus
            button
            onClick={() => {
              setAlertOpen(false);
            }}
          >
            <Button variant="outlined" color="primary" fullWidth>
              Generar otra imagen
            </Button>
          </ListItem>
        </List>
      </Dialog>

      {imagen?.id && (
        <div style={{ width: "1080px", aspectRatio: imagen?.ratio, position: "absolute", zIndex: 3000 }} id="gigante">
          <Imagen
            nombre={nombre}
            hashtag={hashtag}
            ratio={imagen?.ratio as string}
            background={imagen?.background as string}
            onSave={saveImage}
            onReady={() => setDescargable(true)}
            meLlamo={imagen?.meLlamo as boolean}
            style={imagen?.style as any}
          />
        </div>
      )}
      <Container>
        <div>
          <Button
            style={{ marginBottom: "4em" }}
            variant="contained"
            fullWidth
            onClick={() => setOpen((prev) => !prev)}
          >
            Cambiar nombre
          </Button>

          <Dialog open={open} onClose={() => setOpen(false)}>
            <DialogTitle>¡Hola!</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Aquí puedes generar imagenes de apoyo a la campaña de Iván Cepeda para tus redes sociales Instrucciones:{" "}
                <li>
                  <b>1.</b> Escribe tu nombre
                </li>
                <li>
                  <b>2.</b> Selecciona un hashtag
                </li>
                <li>
                  <b>3.</b> Toca el botón para descargar
                  <Fab
                    className="fab"
                    style={{ marginLeft: "1em" }}
                    size="small"
                    color="primary"
                    aria-label="Descargar"
                  >
                    <Icon>download</Icon>
                  </Fab>
                </li>
              </DialogContentText>
              <br />
              <br />
              <TextField
                autoFocus
                margin="dense"
                id="name"
                label="¿Cómo te llamas?"
                type="string"
                value={nombre}
                fullWidth
                variant="standard"
                onChange={(e) => setNombre(e.target.value)}
              />

              <TextField
                select
                value={hashtag}
                onChange={(e) => {
                  setHashtag(e.target.value);
                }}
                SelectProps={{
                  native: true,
                }}
                variant="standard"
              >
                {["IvánPresidente", "UnaCampañaConArte", "PactoConIván", "CambioPorLaVida"].map((option) => (
                  <option key={option} value={option}>
                    #{option}
                  </option>
                ))}
              </TextField>
            </DialogContent>
            <DialogActions>
              <Button variant="contained" onClick={() => setOpen(false)}>
                Generar
              </Button>
            </DialogActions>
          </Dialog>
        </div>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={12}>
            <Grid item lg={4}>
              <Imagen
                nombre={nombre}
                hashtag={hashtag}
                ratio={"1/1"}
                background="profile.png"
                onSave={saveImage}
                meLlamo={false}
                style={{
                  marginTop: "32%",
                }}
              />
            </Grid>
          </Grid>
          <Grid item lg={4}>
            <Imagen
              nombre={nombre}
              hashtag={hashtag}
              ratio={"9/16"}
              background="Instagram story - 1.png"
              onSave={saveImage}
            />
          </Grid>
          <Grid item lg={4}>
            <Imagen
              nombre={nombre}
              hashtag={hashtag}
              ratio={"9/16"}
              background="Instagram story - 2.png"
              onSave={saveImage}
            />
          </Grid>
          <Grid item lg={4}>
            <Imagen
              nombre={nombre}
              hashtag={hashtag}
              ratio={"9/16"}
              background="Instagram story - 3.png"
              onSave={saveImage}
            />
          </Grid>

          <Grid item lg={6}>
            <Imagen
              nombre={nombre}
              hashtag={hashtag}
              ratio={"1/1"}
              background="Instagram post - 1.png"
              onSave={saveImage}
            />
          </Grid>
          <Grid item lg={6}>
            <Imagen
              nombre={nombre}
              hashtag={hashtag}
              ratio={"1/1"}
              background="Instagram post - 1.png"
              onSave={saveImage}
            />
          </Grid>
        </Grid>

        <Grid container mt={4}>
          <Grid item xs={12} lg={6}>
            {redes.map(({ nombre, url, logo }) => (
              <ListItem
                button
                onClick={() => {
                  window.open(url, "_blank");
                  logEvent(analytics, "compartir" + nombre);
                }}
                key={url}
              >
                <ListItemAvatar>
                  <img src={logo} style={{ width: "2em", color: "red", fill: "#ff0000" }} />
                </ListItemAvatar>
                <ListItemText primary={"Compartir en " + nombre} />
              </ListItem>
            ))}
          </Grid>
          <Grid item xs={12} lg={6}>
            <Grid item xs={12}>
              <Typography variant="h6" align="center" gutterBottom>
                <a href="https://api.whatsapp.com/send?phone=573100000001">Créditos de las ilustraciones</a>
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h6" align="center" gutterBottom>
                Versión 1.0
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h6" align="center" gutterBottom>
                Hecho con ☕ por{" "}
                <b>
                  <a href="https://github.com/JohnDoeOrestes">John Doe Orestes</a>
                </b>
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

//usando una lista de colores, asigna un color a cada letra
function colorearString(texto: string) {
  const colores = [
    amarillo,
    azul,
    rojo,
    verde,
    morado,
    verde,
    azul,
    morado,
    rojo,
    verde,
    azul,
    rojo,
    verde,
    morado,
    verde,
    azul,
    morado,
    verde,
    azul,
    morado,
    rojo,
    verde,
    azul,
    rojo,
    verde,
    morado,
    verde,
    azul,
    morado,
    verde,
    azul,
    morado,
    rojo,
    verde,
    azul,
    rojo,
    verde,
    morado,
    verde,
    azul,
    morado,
  ];
  return (
    <>
      {texto
        .toUpperCase()
        .replaceAll(" ", "-")
        .split("")
        .map((letra, i) => {
          return letra != "-" ? (
            <span key={i} style={{ color: colores[i], margin: 0 }}>
              {letra}
            </span>
          ) : (
            <span key={i} style={{ left: "2em", opacity: 0 }}>
              __
            </span>
          );
        })}
    </>
  );
}

export default App;
